import styled from 'styled-components';

import bgInit from '@/assets/img/gift-shelf-init.png';
import bgChoose from '@/assets/img/gift-shelf-choose.png';
export default styled.div`
  .add-button {
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #2196f3;
    height: 26px;
    line-height: 26px;
    font-size: 13px;
    font-weight: 500;
    color: #2196f3;
    padding: 0 12px;
    display: flex;
    align-items: center;
    cursor: pointer;
    flex-shrink: 0;
  }
  .goods-shelf-name {
    padding: 0px 16px;
    font-size: 13px;
    background-color: #f6f6f6;
    color: #999999;
    font-weight: 500;
    height: 34px;
    line-height: 34px;
    margin-right: 2px;
    background-image: url(${bgInit});
    background-position: 2px 2px;
    background-size: 7px 7px;
    background-repeat: no-repeat;
  }
  .goods-shelf-name-choose {
    background-color: #2196f3;
    color: #ffffff;
    background-image: url(${bgChoose});
  }
  .goods-shelf-name-delete {
    font-size: 16px;
    color: #e5e5e5;
    opacity: 0.6;
    margin-left: 11px;
    cursor: auto;
    font-weight: 500;
  }
  .goods-shelf-name-choose-delete {
    color: #ffffff;
  }
`;
